"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LlmGeneralStepService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class LlmGeneralStepService {
    /**
     * The main exercise handler using LLM responses.
     *
     * - Sends data to GigaChat and receives coverage/comment.
     * - If necessary, synthesizes audio via YandexSpeechKitService
     * - Returns audio (audio/mpeg). Passes X-Comment and X-Coverage in the headers.
     *
     * Вход - JSON:
     * {
         * "picture_description": "...",
         * "dialogue_flow": [{"assistant":"...", "answer":"..."}],
         * "lang_id": 1,
         * "need_tts": true
         * }
         *
         * Выход - HttpResponse(audio_bytes) with headers:
         * "X-Coverage": 0.83,
         * "X-Comment": "Кто рядом с мальчиком?",
         * @returns any No response body
         * @throws ApiError
         */
    static llmGeneralStepCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/llm_general_step',
        });
    }
}
exports.LlmGeneralStepService = LlmGeneralStepService;
